export const backendUrl = import.meta.env.VITE_BACKENDURL;
//   || "https://carzlane-backend.herokuapp.com";

export const floorCompany = "Floor Company";
export const vehicleTransporter = "Transport Company";
export const auctionCompany = "Auction Company";
export const bank = "Bank";

export const dealershipID = import.meta.env.VITE_DEALERSHIP;
export const stripeKey = import.meta.env.VITE_STRIPE_KEY;
export const componentPassword = import.meta.env.VITE_PASSWORD_RESTRICTION;
